import type { FormInstance } from '@arco-design/web-react';

import { clearNestedFormFields } from '../shared/formFieldUtils';
import type { ComputePaths } from '../types';
import { readGpuFromForm } from './cpu';
import { resolveVendorDevicePath } from './paths';

export function clearCpuFields(form: FormInstance, paths: ComputePaths) {
  const patch: Record<string, unknown> = {
    [paths.cpuCards]: undefined,
    [paths.cpuCores]: undefined,
    [paths.cpuLogical]: undefined,
  };
  if (paths.cpuRequest) {
    patch[paths.cpuRequest] = undefined;
  }
  form.setFieldsValue(patch);
  clearNestedFormFields(form, resolveVendorDevicePath('cpu', paths), form.getFieldValue(resolveVendorDevicePath('cpu', paths)));
}

export function clearMemoryFields(form: FormInstance, paths: ComputePaths) {
  form.setFieldValue(paths.memory, undefined);
  clearNestedFormFields(form, resolveVendorDevicePath('memory', paths), form.getFieldValue(resolveVendorDevicePath('memory', paths)));
}

export function clearGpuFields(form: FormInstance, paths: ComputePaths) {
  clearNestedFormFields(form, paths.gpu, readGpuFromForm(form.getFieldsValue(), paths.gpu));
  if (paths.gpuPricing) {
    clearNestedFormFields(form, paths.gpuPricing, form.getFieldValue(paths.gpuPricing));
  }
}
